import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";

const TableDiscountComponent = ({ columns, results }) => {
  const isXs = useMediaQuery("(max-width:500px)");
  const tableWidth = isXs ? "100%" : "30%";

  return (
    <div
      style={{
        width: tableWidth,
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <TableContainer component={Box} style={{ width: "30%" }}>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.field}
                  style={{
                    backgroundColor: "#f2f2f2",
                    color: "#333",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {column.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {results.map((row) => (
              <TableRow key={row.id}>
                {columns.map((column) => (
                  <TableCell key={column.field} style={{ textAlign: "center" }}>
                    {column.enum
                      ? column.enum[row[column.field]]
                      : row[column.field]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default TableDiscountComponent;
